import { Box, Text, Heading } from '../../../../../../../../mads';
import { MarkupWrapper } from '../MarkupWrapper';

import React from 'react';

export type PrimaryHeadingProps = {
    title: string;
    subtitleProps?: { linkAriaLabel?: string; label: string; rtl?: boolean; sx?: any };
};

export const PrimaryHeading: React.FunctionComponent<PrimaryHeadingProps> = ({
    title,
    subtitleProps,
}) => (
    <Box
        sx={{
            marginBottom: 24,
            marginTop: 4,
        }}
    >
        <Heading level={4} sx={{ marginBottom: 0 }}>
            {title}
        </Heading>
        {subtitleProps && (
            <Text
                level={1}
                variant="secondary"
                sx={{
                    alignItems: 'baseline', // Changed from center to baseline
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                }}
                accessible={true}
            >
                <MarkupWrapper {...subtitleProps} />
            </Text>
        )}
    </Box>
);
